// packages/web/src/components/layout/headers/BaseHeader.tsx
// FAANG-GRADE: Common header structure shared across all layouts
// Provides consistent AppBar foundation while allowing role-specific content

import { AppBar, Box, Toolbar, useTheme } from '@mui/material';
import React from 'react';

interface BaseHeaderProps {
  children: React.ReactNode;
  branding?: React.ReactNode; // Left side branding area
  actions?: React.ReactNode; // Right side actions area
  catalogBranding?: {
    primaryColor?: string;
  }; // For gradient background
  sx?: any; // Additional styling
}

export const BaseHeader: React.FC<BaseHeaderProps> = ({
  children,
  branding,
  actions,
  catalogBranding,
  sx,
}) => {
  const theme = useTheme();

  // Create gradient background using primary brand color
  const primaryColor = catalogBranding?.primaryColor || '#D4AF37';
  const gradientBackground = `linear-gradient(90deg, white 0%, rgba(255, 255, 255, 0.95) 30%, ${primaryColor} 100%)`;

  return (
    <AppBar
      position="fixed"
      sx={{
        width: '100%',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        background: gradientBackground,
        color: 'text.primary',
        borderBottom: '1px solid',
        borderColor: 'divider',
        overflow: 'visible',
        ...sx,
      }}
    >
      <Toolbar sx={{ minHeight: '64px', px: { xs: 2, sm: 3 } }}>
        {/* Left side - Branding */}
        {branding && (
          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: 2 }}>{branding}</Box>
        )}

        {/* Center content - Role specific elements */}
        {children}

        {/* Right side - Actions */}
        {actions && <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>{actions}</Box>}
      </Toolbar>
    </AppBar>
  );
};
